
// Define base path segments
export const BASE_PATHS = {
  HOME: "/",
  ADMIN: "/admin",
  AUTH: "/auth",
};

// Define path constants to be used throughout the application
export const PATH_CONSTANTS = {
  // Main routes
  HOME: BASE_PATHS.HOME,
  LANDING: "/landing",
  ABOUT: "/about",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  SERVICES: "/services",
  SERVICE_VIEW: "/service/:slug",
  AUTH: BASE_PATHS.AUTH,
  AUTH_REQUEST_RESET: `${BASE_PATHS.AUTH}/request-reset-password`,
  AUTH_RESET: `${BASE_PATHS.AUTH}/reset-password`,
  PROFILE: "/profile",
  CONVERSATIONS: "/conversations",
  CONVERSATIONS_ID: "/conversations/:conversationId",
  SERVICE_REQUEST: "/service-request",
  SERVICE_REQUEST_EDIT: "/service-request/:serviceRequestId",
  SERVICE_REQUEST_CHAT: "/service-request/:id",
  SERVICE_REQUEST_REVIEW: "/service-request/:serviceRequestId/review",
  REVIEW_POTENTIAL_MATCH: "/review-potential-match",
  MY_SERVICE_REQUESTS: "/my-service-requests",
  MY_SERVICE_REQUESTS_ID: "/my-service-requests/:serviceRequestId",
  REGISTER_BUSINESS: "/register-business",
  COMPLETE_REGISTRATION: "/complete-registration",
  
  // Admin routes
  ADMIN: BASE_PATHS.ADMIN,
  ADMIN_DASHBOARD: BASE_PATHS.ADMIN,
  ADMIN_COMMUNITY: `${BASE_PATHS.ADMIN}/community`,
  ADMIN_CATEGORIES: `${BASE_PATHS.ADMIN}/categories`,
  ADMIN_BADGES: `${BASE_PATHS.ADMIN}/badges`,
  ADMIN_USERS: `${BASE_PATHS.ADMIN}/users`,
  ADMIN_BUSINESSES: `${BASE_PATHS.ADMIN}/businesses`,
  ADMIN_REVIEWS: `${BASE_PATHS.ADMIN}/reviews`,
  ADMIN_DISCOUNTS: `${BASE_PATHS.ADMIN}/discounts`,
  ADMIN_TRANSLATIONS: `${BASE_PATHS.ADMIN}/translations`,
  ADMIN_EMAIL_TEMPLATES: `${BASE_PATHS.ADMIN}/email-templates`,
  ADMIN_COMMUNICATIONS: `${BASE_PATHS.ADMIN}/communications`,
  ADMIN_CAMPAIGNS: `${BASE_PATHS.ADMIN}/campaigns`,
  ADMIN_CONTENT_MANAGEMENT: `${BASE_PATHS.ADMIN}/content-management`,
  ADMIN_MY_BUSINESS: `${BASE_PATHS.ADMIN}/my-business`,
  ADMIN_MY_JOB_OPPORTUNITIES: `${BASE_PATHS.ADMIN}/my-job-opportunities`,
  ADMIN_JOB_PROPOSAL_DETAIL: `${BASE_PATHS.ADMIN}/my-job-opportunities/:proposalId`,
  ADMIN_BUSINESS_CHAT: `${BASE_PATHS.ADMIN}/business-chat`,
  ADMIN_INTEGRATIONS: `${BASE_PATHS.ADMIN}/integrations`,
  ADMIN_SUBSCRIPTION_FEATURES: `${BASE_PATHS.ADMIN}/subscription-features`,
  
  // Subscription routes
  ADMIN_SUBSCRIPTION: `${BASE_PATHS.ADMIN}/business/subscription`,
  ADMIN_SUBSCRIPTION_SUCCESS: `${BASE_PATHS.ADMIN}/business/subscription/success`,
  ADMIN_SUBSCRIPTION_CANCEL: `${BASE_PATHS.ADMIN}/business/subscription/cancel`,
};

// Admin nested path segments (used for nested routes)
export const ADMIN_PATH_SEGMENTS = {
  ROOT: "",
  COMMUNITY: "community",
  CATEGORIES: "categories",
  BADGES: "badges",
  USERS: "users",
  BUSINESSES: "businesses",
  REVIEWS: "reviews",
  DISCOUNTS: "discounts",
  TRANSLATIONS: "translations",
  EMAIL_TEMPLATES: "email-templates",
  COMMUNICATIONS: "communications",
  CAMPAIGNS: "campaigns",
  CONTENT_MANAGEMENT: "content-management",
  MY_BUSINESS: "my-business",
  MY_JOB_OPPORTUNITIES: "my-job-opportunities",
  JOB_PROPOSAL_DETAIL: "my-job-opportunities/:proposalId",
  BUSINESS_CHAT: "business-chat",
  INTEGRATIONS: "integrations",
  SUBSCRIPTION_FEATURES: "subscription-features",
  SUBSCRIPTION: "business/subscription",
  SUBSCRIPTION_SUCCESS: "business/subscription/success",
  SUBSCRIPTION_CANCEL: "business/subscription/cancel",
};
